import type {
  TrainingLocalizationState,
} from "./slices/TrainingLocalizationSlice";
import type { TrainingState } from "./slices/TrainingSlice";

export type TrainingDocumentState = Pick<
  TrainingState,
  | "trainingName"
  | "trainingDescription"
  | "takes360"
  | "takes3D"
  | "referenceLanguage"
  | "trainingType"
  | "actors"
  | "props"
  | "selectedEnvironmentLayerIds"
  | "sequenceVariables"
  | "disableProgressBar"
>;

export type LocalizationDocumentState = Pick<
  TrainingLocalizationState,
  "localizedEntries" | "propLocalizedEntries" | "localizedLanguages"
>;

export interface DocumentSnapshot {
  training: TrainingDocumentState;
  trainingLocalization: LocalizationDocumentState;
}

type DocumentRootState = {
  training: TrainingState;
  trainingLocalization: TrainingLocalizationState;
};

export function extractDocumentSnapshot(
  state: DocumentRootState
): DocumentSnapshot {
  const { training, trainingLocalization } = state;

  return {
    training: {
      trainingName: training.trainingName,
      trainingDescription: training.trainingDescription,
      takes360: training.takes360,
      takes3D: training.takes3D,
      referenceLanguage: training.referenceLanguage,
      trainingType: training.trainingType,
      actors: training.actors,
      props: training.props,
      selectedEnvironmentLayerIds: training.selectedEnvironmentLayerIds,
      sequenceVariables: training.sequenceVariables,
      disableProgressBar: training.disableProgressBar,
    },
    trainingLocalization: {
      localizedEntries: trainingLocalization.localizedEntries,
      propLocalizedEntries: trainingLocalization.propLocalizedEntries,
      localizedLanguages: trainingLocalization.localizedLanguages,
    },
  };
}

export function cloneDocumentSnapshot(
  snapshot: DocumentSnapshot
): DocumentSnapshot {
  if (typeof globalThis.structuredClone === "function") {
    return globalThis.structuredClone(snapshot);
  }
  return JSON.parse(JSON.stringify(snapshot)) as DocumentSnapshot;
}

export function documentSnapshotsEqual(
  left: DocumentSnapshot,
  right: DocumentSnapshot
): boolean {
  if (left === right) return true;
  return JSON.stringify(left) === JSON.stringify(right);
}

export function restoreDocumentSnapshot(
  state: DocumentRootState,
  snapshot: DocumentSnapshot
): Pick<DocumentRootState, "training" | "trainingLocalization"> {
  return {
    training: {
      ...state.training,
      ...snapshot.training,
    },
    trainingLocalization: {
      ...state.trainingLocalization,
      ...snapshot.trainingLocalization,
    },
  };
}
